import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { LoginComponent } from './components/loginComponents/login/login.component';
import { RegistrationComponent } from './components/loginComponents/registration/registration.component';
import { ForgetPasswordComponent } from './components/loginComponents/forget-password/forget-password.component';
import { ResetPasswordComponent } from './components/loginComponents/reset-password/reset-password.component';
import { DashboardComponent } from './components/loginComponents/dashboard/dashboard.component';
import { NavbarComponent } from './components/loginComponents/navbar/navbar.component';
import { CustomerProfileSetupComponent } from './components/customerRegistration/customer-profile-setup/customer-profile-setup.component';
import { CustomerTaxAccountSetupComponent } from './components/customerRegistration/customer-tax-account-setup/customer-tax-account-setup.component';
import { CustomerBankAccountSetupComponent } from './components/customerRegistration/customer-bank-account-setup/customer-bank-account-setup.component';
import { CustomerProductServiceSetupComponent } from './components/customerRegistration/customer-product-service-setup/customer-product-service-setup.component';
import { LoanlogicsPricingServiceFeeSetupComponent } from './components/customerRegistration/loanlogics-pricing-service-fee-setup/loanlogics-pricing-service-fee-setup.component';
import { CustomerBrandingProfileSetupComponent } from './components/customerRegistration/customer-branding-profile-setup/customer-branding-profile-setup.component';
import { CustomerPersonalizedEmailNotificationComponent } from './components/customerRegistration/customer-personalized-email-notification/customer-personalized-email-notification.component';
import { CreateOrderComponent } from './components/payeePaymentLinks/create-order/create-order.component';
import { AddPayeeComponent } from './components/payeePaymentLinks/add-payee/add-payee.component';
import { SetupPayeeInvoiceComponent } from './components/payeePaymentLinks/setup-payee-invoice/setup-payee-invoice.component';
import { CreatePaymentLinkComponent } from './components/payeePaymentLinks/create-payment-link/create-payment-link.component';
import { SavePaymentDetailsComponent } from './components/payeePaymentLinks/save-payment-details/save-payment-details.component';
import { PromotionCodeComponent } from './components/payeePaymentLinks/promotion-code/promotion-code.component';
import { SharePaymentLinkComponent } from './components/payeePaymentLinks/share-payment-link/share-payment-link.component';
import { RecivePaymentNotificationComponent } from './components/payeePaymentLinks/recive-payment-notification/recive-payment-notification.component';
import { TrackPaymentsComponent } from './components/payeePaymentLinks/track-payments/track-payments.component';
import { TrackPayoutsComponent } from './components/payeePaymentLinks/track-payouts/track-payouts.component';
import { CreatePartialRefundComponent } from './components/payeeRefund/create-partial-refund/create-partial-refund.component';
import { TrackRefundComponent } from './components/payeeRefund/track-refund/track-refund.component';
import { CreateDisputeComponent } from './components/createDispute/create-dispute/create-dispute.component';
import { DailyReportsComponent } from './components/dailyWeeklyReports/daily-reports/daily-reports.component';
import { TrackNewCustomerRegitrationComponent } from './components/customerManagement/track-new-customer-regitration/track-new-customer-regitration.component';
import { EditCustomerProfileDataComponent } from './components/customerManagement/edit-customer-profile-data/edit-customer-profile-data.component';
import { ActiveDeactivCustomerComponent } from './components/customerManagement/active-deactiv-customer/active-deactiv-customer.component';
import { CustomerBankAcountSetupComponent } from './components/customerManagement/customer-bank-acount-setup/customer-bank-acount-setup.component';
import { CustomerBrandSetupComponent } from './components/customerManagement/customer-brand-setup/customer-brand-setup.component';
import { CustomerProductSetupComponent } from './components/customerManagement/customer-product-setup/customer-product-setup.component';
import { CustomerPersonalizationEmailSetupComponent } from './components/customerManagement/customer-personalization-email-setup/customer-personalization-email-setup.component';
import { PaymentGatewaySetupComponent } from './components/customerManagement/payment-gateway-setup/payment-gateway-setup.component';
import { TrackOrdersComponent } from './components/trackTransactions/track-orders/track-orders.component';
import { TrackRefundsComponent } from './components/trackTransactions/track-refunds/track-refunds.component';
import { ReportsComponent } from './components/Reports/reports/reports.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { OpspaymentsComponent } from './operations/ops-payments/opspayments.component';
import { OpssettlementComponent } from './operations/ops-settlement/opssettlement.component';
import { OpsremittancesComponent } from './operations/ops-remittances/opsremittances.component';
import { OpsrefundComponent } from './operations/ops-refund/opsrefund.component';
import { OpsdisputesComponent } from './operations/ops-disputes/opsdisputes.component';
import { OpsRemitManagerComponent } from './operations/ops-remit-manager/ops-remit-manager.component';
import { OpsCashProBatchComponent } from './operations/ops-cash-pro-batch/ops-cash-pro-batch.component';
import { OpsSheetComponent } from './operations/ops-sheet/ops-sheet.component';
import { OpsCompletionRemitComponent } from './operations/ops-completion-remit/ops-completion-remit.component';
import { OpsBkRemitComponent } from './operations/ops-bk-remit/ops-bk-remit.component';
import { OpsRevenueShareComponent } from './operations/ops-revenue-share/ops-revenue-share.component';
import { OpsBkRevShareComponent } from './operations/ops-bk-rev-share/ops-bk-rev-share.component';
import { OpsTransactionalGridComponent } from './operations/ops-transactional-grid/ops-transactional-grid.component';
import { OpsNinetyDaysComponent } from './operations/ops-ninety-days/ops-ninety-days.component';
import { OpsAccountingComponent } from './operations/ops-accounting/ops-accounting.component';
import { OpsImportComponent } from './operations/ops-import/ops-import.component';
import { OpsMonthlyAccountingComponent } from './operations/ops-monthly-accounting/ops-monthly-accounting.component';
import { OpsVendorInfoComponent } from './operations/ops-vendor-info/ops-vendor-info.component';

//product
import { SideNavComponent } from './Product/side-nav/side-nav.component';
import { PaymentsComponent } from './Product/payments/payments.component';
import { PaymentLinkComponent } from './Product/payment-link/payment-link.component';
import { DialogexComponent } from './Product/dialogex/dialogex.component';
import { CreatePayementComponent } from './Product/create-payement/create-payement.component';
import { HeaderComponent } from './Product/header/header.component';
import { FooterComponent } from './Product/footer/footer.component';
import { BankDetailsComponent } from './Product/bank-details/bank-details.component';
import { CompanyDetailsComponent } from './Product/company-details/company-details.component';
import { PublicDetailsComponent } from './Product/public-details/public-details.component';
import { ProductSettingComponent } from './Product/product-setting/product-setting.component';
import { PaymentTransactionComponent } from './Product/payment-transaction/payment-transaction.component';
import { VendorsComponent } from './Product/vendors/vendors.component';
import { MyProfileComponent } from './Product/my-profile/my-profile.component';
import { EditVendorComponent } from './Product/edit-vendor/edit-vendor.component';
import { AddNewVendorComponent } from './Product/add-new-vendor/add-new-vendor.component';
import { ConfirmNewVendorComponent } from './Product/confirm-add-new-vendor/confirm-new-vendor/confirm-new-vendor.component';
import { RegisterComponent } from './Product/register/register.component';
import { SignInComponent } from './Product/sign-in/sign-in.component';
import { RefundComponent } from './Product/refund/refund.component';
import { RefundRequestComponent } from './Product/refund-request/refund-request.component';
import { ConfirmAddNewVendorComponent } from './Product/confirm-add-new-vendor/confirm-add-new-vendor.component';
import { TransactionDetailPageComponent } from './Product/transaction-detail-page/transaction-detail-page.component';
import { RaiseRefundRequestComponent } from './Product/raise-refund-request/raise-refund-request.component';
import { RefundAmountComponent } from './Product/refund-amount/refund-amount.component';
import { RefundRequestSuccessComponent } from './Product/refund-request-success/refund-request-success.component';
import { PaymentLinkInformationComponent } from './Product/payment-link-information/payment-link-information.component';
import { DashboardCompComponent } from './Product/dashboard-comp/dashboard-comp.component';
import { MainDashboardComponent } from './Product/main-dashboard/main-dashboard.component';
import { AllCompoComponent } from './Product/all-compo/all-compo.component';
import { InactiveUserComponent } from './Product/inactive-user/inactive-user.component';
import { InactiveSideNavComponent } from './Product/inactive-side-nav/inactive-side-nav.component';
import { InactiveHeaderComponent } from './Product/inactive-header/inactive-header.component';
import { InactiveAllComponent } from './Product/inactive-all/inactive-all.component';
import { AuthComponent } from './Product/auth/auth.component';
import { ForgotPasswordComponent } from './Product/forgot-password/forgot-password.component';
import { UpdateBankComponent } from './Product/update-bank/update-bank.component';
import { UpdateCompanyComponent } from './Product/update-company/update-company.component';
import { OnlynumberDirectiveDirective } from './directives/onlynumber-directive.directive';
//import { AlertComponent } from './_alert/alert/alert.component';
//import { PasswordValidatorsComponent } from './product/password-validators/password-validators.component';
import { AlertModule } from './_alert';
import { VendortakenComponent } from './Product/vendortaken/vendortaken.component';
import { SameEmailComponent } from './Product/same-email/same-email.component';
import { ConfirmCreatePaymentComponent } from './Product/confirm-create-payment/confirm-create-payment.component';
import { ConfirmBoxCreatePaymentComponent } from './Product/confirm-box-create-payment/confirm-box-create-payment.component';
import { UploaderComponent } from './Product/uploader/uploader.component';
import { SuccessPopUpComponent } from './Product/popup/success-pop-up/success-pop-up.component';
import { ErrorPopUpComponent } from './Product/popup/error-pop-up/error-pop-up.component';
import { ExpirePopUpComponent } from './Product/popup/expire-pop-up/expire-pop-up.component';
import { MaxAttemptPopUpComponent } from './Product/popup/max-attempt-pop-up/max-attempt-pop-up.component';
import { SessionTimeOutComponent } from './Product/popup/session-time-out/session-time-out.component';
import { ConfirPopUpComponent } from './Product/popup/confir-pop-up/confir-pop-up.component';
import { ProcessedComponent } from './Product/popup/processed/processed.component';
import { ForgotPassComponent } from './Product/forgot-pass/forgot-pass.component';
import { ResetPassComponent } from './Product/reset-pass/reset-pass.component';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { LoaderComponent } from './common/loader/loader.component';
import { PhoneDirective } from './directives/phone.directive';
import { PhoneNumberFormatPipe } from './pipes/phone-number-format.pipe';
import { FourDigitDirectiveDirective } from './directives/four-digit-directive.directive';
import { ContentTypeInterceptor } from './_interceptor/content-type.interceptor';
import { keys } from 'lodash-es';
import { NumericOnlyDirective } from './directives/numeric-only.directive';
import { NumericDirective } from './directives/numeric.directive';
import { CancelRefundComponent } from './Product/cancelRefund/cancel-refund/cancel-refund.component';
import { CancelMainRefundComponent } from './Product/cancelRefund/cancel-main-refund/cancel-main-refund.component';
import { CancelRefundSuccessComponent } from './Product/cancelRefund/cancel-refund-success/cancel-refund-success.component';
import { RefundRequestDetailsComponent } from './Product/refund-request-details/refund-request-details.component';
import { CancelPaymentComponent } from './Product/cancel-payment/cancel-payment.component';
import { ConfirmCancelPaymentComponent } from './Product/cancel-payment/confirm-cancel-payment/confirm-cancel-payment.component';
import { CancelPayPopupComponent } from './Product/popup/cancel-pay-popup/cancel-pay-popup.component';
import { CancelPaymentSuccessComponent } from './Product/cancel-payment/cancel-payment-success/cancel-payment-success.component';
import { ResizeColumnDirective } from './directives/resize-column.directive';
import { MainDashComponent } from './Product/main-dash/main-dash.component';
import { ActiveLinkDirective } from './directives/active-link.directive';
import { EmailComponent } from './Product/email/email.component';
import { Scroll } from '@angular/router';
import { VendorDashboardComponent } from 'src/app/Product/vendorScreen/vendor-dashboard/vendor-dashboard.component';
// import { VendorDashboardComponent } from 'src/app/Product/vendorScreen/vendor-dashboard/vendor-dashboard.component';
import { VendorPublicDetailsComponent } from './Product/vendorScreen/vendor-public-details/vendor-public-details.component';
import { VendorChangePassworsComponent } from './Product/vendorScreen/vendor-change-passwors/vendor-change-passwors.component';
import { VendorProfileComponent } from './Product/vendorScreen/vendor-profile/vendor-profile.component';
import { VendorPayTransComponent } from './Product/vendorScreen/vendor-pay-trans/vendor-pay-trans.component';
import { VendorTransDetailsComponent } from './Product/vendorScreen/vendor-trans-details/vendor-trans-details.component';
import { VendorRefundComponent } from './Product/vendorScreen/vendor-refund/vendor-refund.component';
import { VendorSideNavComponent } from 'src/app/Product/vendorScreen/vendor-side-nav/vendor-side-nav.component';
import { VendorAllCompComponent } from 'src/app/Product/vendorScreen/vendor-all-comp/vendor-all-comp.component';
import { VendorHeaderComponent } from './Product/vendorScreen/vendor-header/vendor-header.component';
import { MailComponent } from './Product/popup/mail/mail.component';
import { ActiveVendorComponent } from './Product/popup/active-vendor/active-vendor.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    DashboardComponent,
    NavbarComponent,
    CustomerProfileSetupComponent,
    CustomerTaxAccountSetupComponent,
    CustomerBankAccountSetupComponent,
    CustomerProductServiceSetupComponent,
    LoanlogicsPricingServiceFeeSetupComponent,
    CustomerBrandingProfileSetupComponent,
    CustomerPersonalizedEmailNotificationComponent,
    CreateOrderComponent,
    AddPayeeComponent,
    SetupPayeeInvoiceComponent,
    CreatePaymentLinkComponent,
    SavePaymentDetailsComponent,
    PromotionCodeComponent,
    SharePaymentLinkComponent,
    RecivePaymentNotificationComponent,
    TrackPaymentsComponent,
    TrackPayoutsComponent,
    CreatePartialRefundComponent,
    TrackRefundComponent,
    CreateDisputeComponent,
    DailyReportsComponent,
    TrackNewCustomerRegitrationComponent,
    EditCustomerProfileDataComponent,
    ActiveDeactivCustomerComponent,
    CustomerBankAcountSetupComponent,
    CustomerBrandSetupComponent,
    CustomerProductSetupComponent,
    CustomerPersonalizationEmailSetupComponent,
    PaymentGatewaySetupComponent,
    TrackOrdersComponent,
    TrackRefundsComponent,
    ReportsComponent,
    OpspaymentsComponent,
    OpssettlementComponent,
    OpsremittancesComponent,
    OpsrefundComponent,
    OpsdisputesComponent,
    OpsRemitManagerComponent,
    OpsCashProBatchComponent,
    OpsSheetComponent,
    OpsCompletionRemitComponent,
    OpsBkRemitComponent,
    OpsRevenueShareComponent,
    OpsBkRevShareComponent,
    OpsTransactionalGridComponent,
    OpsNinetyDaysComponent,
    OpsAccountingComponent,
    OpsImportComponent,
    OpsMonthlyAccountingComponent,
    OpsVendorInfoComponent,
    SideNavComponent,
    PaymentsComponent,
    PaymentLinkComponent,
    DialogexComponent,
    CreatePayementComponent,
    HeaderComponent,
    FooterComponent,
    BankDetailsComponent,
    CompanyDetailsComponent,
    PublicDetailsComponent,
    ProductSettingComponent,
    PaymentTransactionComponent,
    VendorsComponent,
    MyProfileComponent,

    EditVendorComponent,
    AddNewVendorComponent,
    ConfirmNewVendorComponent,
    RegisterComponent,
    SignInComponent,
    RefundComponent,
    RefundRequestComponent,
    ConfirmAddNewVendorComponent,
    TransactionDetailPageComponent,
    RaiseRefundRequestComponent,
    RefundAmountComponent,
    RefundRequestSuccessComponent,
    PaymentLinkInformationComponent,
    DashboardCompComponent,
    MainDashboardComponent,
    AllCompoComponent,
    InactiveUserComponent,
    InactiveSideNavComponent,
    InactiveHeaderComponent,
    InactiveAllComponent,
    AuthComponent,
    ForgotPasswordComponent,
    UpdateBankComponent,
    UpdateCompanyComponent,
    OnlynumberDirectiveDirective,
    VendortakenComponent,
    SameEmailComponent,
    ConfirmCreatePaymentComponent,
    ConfirmBoxCreatePaymentComponent,
    UploaderComponent,
    SuccessPopUpComponent,
    ErrorPopUpComponent,
    ExpirePopUpComponent,
    MaxAttemptPopUpComponent,
    SessionTimeOutComponent,
    ConfirPopUpComponent,
    ProcessedComponent,
    ForgotPassComponent,
    ResetPassComponent,
    TrackPayoutsComponent,
    PhoneMaskDirective,
    LoaderComponent,
    PhoneDirective,
    PhoneNumberFormatPipe,
    FourDigitDirectiveDirective,
    NumericOnlyDirective,
    NumericDirective,
    CancelRefundComponent,
    CancelMainRefundComponent,
    CancelRefundSuccessComponent,
    RefundRequestDetailsComponent,
    CancelPaymentComponent,
    ConfirmCancelPaymentComponent,
    CancelPayPopupComponent,
    CancelPaymentSuccessComponent,
    ResizeColumnDirective,
    MainDashComponent,
    ActiveLinkDirective,
    EmailComponent,
    VendorDashboardComponent,
    VendorPublicDetailsComponent,
    VendorChangePassworsComponent,
    VendorProfileComponent,
    VendorPayTransComponent,
    VendorTransDetailsComponent,
    VendorRefundComponent,
    VendorSideNavComponent,
    VendorAllCompComponent,
    VendorHeaderComponent,
    MailComponent,
    ActiveVendorComponent,
    //AlertComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    AlertModule,
    // NgIdleKeepaliveModule.forRoot(),
    // MomentModule
  ],
  providers: [,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ContentTypeInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
